<template lang="pug">
  v-slide-y-transition(mode="out-in")

    v-container(fluid v-if="!isLoading()")

      v-form(ref="userForm", @submit='handleSubmit')

        v-card(class="mb2")

          v-card-title
            h3.headline Datos generales

          v-card-text
            v-layout(row wrap)
              v-flex(xs12 sm6)
                v-text-field(:label="$t('E-mail')", v-model="user.email", :rules="validation.required", required)
              v-flex(xs12 sm6)
                v-text-field(:label="$t('Password')", type="password", v-model="user.password", persistent-hint, :hint="user.id ? 'Dejarlo en blanco si no se quiere cambiar' : ''")
              v-flex(xs12 sm6)
                v-text-field(:label="$t('Nombre')", v-model="user.firstName", :rules="validation.required", required)
              v-flex(xs12 sm6)
                v-text-field(:label="$t('Apellidos')", v-model="user.lastName", :rules="validation.required", required)

            v-select(multiple, :label="$t('Roles')", return-object, v-model="user.roles", :rules="validation.required", required, :items="roleTypes")

          v-card-title(v-if="user.roles.indexOf('AGENCY') > -1")
            h3.headline Datos de agencia

          v-card-text(v-if="user.roles.indexOf('AGENCY') > -1")
            v-layout(row wrap)
              v-flex(xs12 sm6)
                v-select(:hint="user.info.commercialChainName", return-object, :persistent-hint="true", :label="$t('Grupo de agencias')", @input="handleCommercialChainChange()" v-model="user.info.commercialChain", :items="commercialChains", item-text="name")
              v-flex(xs12 sm3)
                v-text-field(:label="$t('Identificador de grupo')", v-model="user.info.commercialChainIdentifier")
              v-flex(xs12 sm3)
                v-text-field(:label="$t('Comisión')", v-model="user.info.commission")

          v-card-title(v-if="user.roles.indexOf('AGENCY') > -1 || user.roles.indexOf('USER') > -1")
            h3.headline Datos de usuario

          v-card-text(v-if="user.roles.indexOf('AGENCY') > -1 || user.roles.indexOf('USER') > -1")
            v-layout(row wrap)
              v-flex(xs12, :class="{sm3: user.roles.indexOf('AGENCY') < 0, sm6: user.roles.indexOf('AGENCY') > -1}")
                v-text-field(:label="$t('Nombre comercial')", v-model="user.info.commercialName", :rules="isAgency() ? validation.required : []", :required="isAgency()")
              v-flex(xs12 sm3)
                v-text-field(:label="$t('Nombre fiscal')", v-model="user.info.fiscalName", :rules="isAgency() ? validation.required : []", :required="isAgency()")
              v-flex(xs12 sm3)
                v-text-field(:label="$t('NIF/CIF/VAT')", v-model="user.info.vat")
              v-flex(xs12 sm3, v-if="user.roles.indexOf('AGENCY') < 0")
                v-text-field(:label="$t('Grupo')", v-model="user.info.commercialChainIdentifier")
              v-flex(xs12 sm6)
                v-text-field(:label="$t('Nº cuenta contable')", v-model="user.info.contableAccount")
              v-flex(xs12 sm6)
                v-text-field(:label="$t('Teléfono')", v-model="user.info.phone")

            v-text-field(:label="$t('Dirección')", v-model="user.info.address")

            v-layout(row wrap)
              v-flex(xs12 sm6 md4)
                v-text-field(:label="$t('Ciudad')", v-model="user.info.town")
              v-flex(xs12 sm6 md3)
                v-text-field(:label="$t('Provincia')", v-model="user.info.state")
              v-flex(xs12 sm4 md2)
                v-text-field(:label="$t('Código Postal')", v-model="user.info.zip")
              v-flex(xs12 sm8 md3)
                v-autocomplete(:label="$t('Pais')", v-model="user.info.country", :items="countries", item-text="name", item-value="code")

          v-card-actions
            v-btn(color="red" dark @click="$router.push('/users')") Cancelar
            v-spacer
            v-btn(color="primary", type="submit") Guardar

    v-container(fluid fill-height v-else)
      v-layout(flex align-center justify-center)
        v-progress-circular(indeterminate, color="primary", :size="128", :width="2")
</template>

<script>
  import validation from '@/utils/validation';

  const emptyUser = () => {
    const user = {
      id: null,
      email: null,
      password: null,
      roles: [],
      info: {
        commission: null,
        commercialName: null,
        fiscalName: null,
        vat: null,
        contableAccount: null,
        commercialChain: null,
        commercialChainIdentifier: null,
        address: null,
        town: null,
        state: null,
        zip: null,
        country: null,
        phone: null,
      },
    };
    return user;
  };

  export default {
    data() {
      return {
        user: null,
        commercialChains: [],
        roleTypes: [],
        loading: {
          user: false,
          commercialChains: false,
          roleTypes: false,
          saving: false,
          countries: false,
        },
        validation,
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      isLoading() {
        return this.loading.user
          || this.loading.roleTypes
          || this.loading.countries
          || this.loading.commercialChains
          || this.loading.saving;
      },
      fetchData() {
        this.loading.user = true;
        this.loading.roleTypes = true;
        this.loading.commercialChains = true;
        this.loading.countries = true;

        if (this.$route.params.id) {
          api.get(`/users/${this.$route.params.id}`).then((res) => {
            this.user = res.data;
            if (this.user.info === null) {
              this.user.info = Object.assign({}, emptyUser().info);
            }
          }).catch(this.handleError)
          .finally(() => {
            this.loading.user = false;
            this.setupCommercialChain();
          });
        } else {
          this.user = Object.assign({}, emptyUser());
          this.loading.user = false;
        }

        api.get('/types/roles').then((res) => {
          this.roleTypes = res.data;
        }).catch(this.handleError)
        .finally(() => { this.loading.roleTypes = false; });

        api.get('/commercial_chains').then((res) => {
          this.commercialChains = res.data;
        }).catch(this.handleError)
        .finally(() => {
          this.loading.commercialChains = false;
          this.setupCommercialChain();
        });

        api.get('/countries').then((res) => {
          this.countries = res.data;
        }).catch(this.handleError)
        .finally(() => { this.loading.countries = false; });
      },
      setupCommercialChain() {
        if (!this.loading.commercialChains && !this.loading.user) {
          if (this.user.info.commercialChain) {
            const userCCId = this.user.info.commercialChain.id;
            this.user.info.commercialChain =
              this.commercialChains.filter(cc => cc.id === userCCId)[0];
          }
        }
      },
      isAgency() {
        return this.user.roles.indexOf('AGENCY') > -1;
      },
      handleCommercialChainChange() {
        this.user.info.commission = this.user.info.commercialChain.commission;
        this.$forceUpdate();
      },
      handleSubmit() {
        if (this.$refs.userForm.validate()) {
          this.loading.saving = true;
          if (this.user.id === null) {
            api.post('/users', this.user).then(() => {
              this.$router.push('/users');
            }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
          } else {
            api.put(`/users/${this.user.id}`, this.user).then(() => {
              this.$router.push('/users');
            }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
          }
        }
      },
      handleError(err) {
        // eslint-disable-next-line no-console
        console.error(err);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/Users/UserForm.vue